
import React, { PropTypes } from 'react';

export class Eye extends React.Component {

  static propTypes = {
    colorSchema: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string
  };

  render () {
    const fill = this.props.colorSchema === 'primary'
      ? '#00587c'
      : '#000000';

    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={this.props.width || '23'}
        height={this.props.height || '16'}
        viewBox="0 0 23 16"
      >
        <path d={
          'M11.2501 9.25C11.9131 9.25 12.549 8.98661 13.0179 ' +
          '8.51777C13.4867 8.04893 13.7501 7.41304 13.7501 6.75C13.7501 ' +
          '6.08696 13.4867 5.45107 13.0179 4.98223C12.549 4.51339 11.9131 ' +
          '4.25 11.2501 4.25C11.211 4.25 11.1767 4.25937 11.1388 4.26133C11.2592 ' +
          '4.59309 11.2826 4.95234 11.2061 5.2969C11.1295 5.64147 10.9563 5.95706 ' +
          '10.7067 6.20664C10.4572 6.45622 10.1416 6.62944 9.797 6.70596C9.45244 ' +
          '6.78248 9.09319 6.75914 8.76143 6.63867C8.76143 6.67773 8.7501 6.71211 ' +
          '8.7501 6.75C8.7501 7.0783 8.81476 7.40339 8.9404 7.70671C9.06604 8.01002 ' +
          '9.25019 8.28562 9.48233 8.51777C9.95117 8.98661 10.5871 9.25 11.2501 ' +
          '9.25ZM22.3642 7.42969C20.2458 3.29648 16.0521 0.5 11.2501 0.5C6.44815 ' +
          '0.5 2.25323 3.29844 0.136038 7.43008C0.0466796 7.60684 0.00012207 7.80213 ' +
          '0.00012207 8.0002C0.00012207 8.19826 0.0466796 8.39355 0.136038 8.57031C2.2544 ' +
          '12.7035 6.44815 15.5 11.2501 15.5C16.0521 15.5 20.247 12.7016 22.3642 ' +
          '8.56992C22.4535 8.39316 22.5001 8.19787 22.5001 7.9998C22.5001 7.80174 ' +
          '22.4535 7.60645 22.3642 7.42969ZM11.2501 1.75C12.239 1.75 13.2057 2.04324 ' +
          '14.028 2.59265C14.8502 3.14206 15.4911 3.92295 15.8695 4.83658C16.2479 ' +
          '5.75021 16.347 6.75555 16.154 7.72545C15.9611 8.69536 15.4849 9.58627 ' +
          '14.7856 10.2855C14.0864 10.9848 13.1955 11.461 12.2256 11.6539C11.2556 ' +
          '11.8469 10.2503 11.7478 9.33668 11.3694C8.42305 10.991 7.64216 10.3501 ' +
          '7.09275 9.52785C6.54335 8.7056 6.2501 7.73891 6.2501 6.75C6.25155 5.42436 ' +
          '6.7788 4.15343 7.71617 3.21606C8.65353 2.2787 9.92446 1.75145 11.2501 ' +
          '1.75ZM11.2501 14.25C7.05635 14.25 3.22432 11.8551 1.2501 8C2.36042 5.82028 ' +
          '4.13607 4.05079 6.31963 2.94805C5.5044 4.00352 5.0001 5.31133 5.0001 ' +
          '6.75C5.0001 8.4076 5.65858 9.99732 6.83068 11.1694C8.00279 12.3415 9.5925 ' +
          '13 11.2501 13C12.9077 13 14.4974 12.3415 15.6695 11.1694C16.8416 9.99732 ' +
          '17.5001 8.4076 17.5001 6.75C17.5001 5.31133 16.9958 4.00352 16.1806 ' +
          '2.94805C18.3641 4.05079 20.1398 5.82028 21.2501 8C19.2763 11.8551 ' +
          '15.4439 14.25 11.2501 14.25Z'}
          fill={fill} />
      </svg>
    );
  }
}

export default Eye;



/** WEBPACK FOOTER **
 ** ./src/components/svg/eye.js
 **/